import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import AppointmentProductDetail from '../QuoterComponents/AppointmentProductDetail';
import ScheduleForm from '../QuoterComponents/ScheduleForm';
import TimeZones from '../../Common/Appointment/Timezones';
import CustomTermCards from '../QuoterComponents/CustomTermCards';
import { getSessionStorageItem, SESSION_STORAGE_CUSTOMIZED_HEALTH_KEY } from '../../../../sessionStorage';
import './SelectAppointment.scss';

export default function SelectAppointment(props) {
  const navigate = useNavigate();
  const sessionStorageHealthData = getSessionStorageItem(SESSION_STORAGE_CUSTOMIZED_HEALTH_KEY);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  
  const goBack = () => {
    navigate(-1); 
  };

  return (
    <Container className='custom-appointment-info py-4'>
      <Row>
        <Col md={6} className="review-container d-flex align-items-center w-100">
          <div className="coverage-detail-container">
            <AppointmentProductDetail quote={props.quoter}/>
          </div>
          <CustomTermCards title={props.title} data={props.data}/>
        </Col>
        <Col md={6} lg={4} className='mx-auto'>
          <ScheduleForm
            activeQuestionList={props.activeQuestionList}
            formState={props.formState}
            basicInfo={props.basicInfo}
            quoter={props.quoter}
            journeyType={props.journeyType}
            onFieldChange={(field, value) => props.onFieldChange(field, value)}
            setFormState={props.setFormState}
            onNext={props.onNext}
            onBack={goBack}
            setMultiField={props.setMultiField}
            sessionStorageHealthData={sessionStorageHealthData}
          />
        </Col>
      </Row>
    </Container>
  )
}

SelectAppointment.DefaultFormState = (prefill = false, basicInfo = null, activeQuestionList = []) => {
  return {
    firstName: prefill ? 'Example' : (basicInfo && basicInfo.firstName) || '',
    lastName: prefill ? 'Consumer' : (basicInfo && basicInfo.lastName) || '',
    email: prefill ? 'user@address.com' : (basicInfo && basicInfo.email) || '',
    specificAppt: 'asap',
    timeZone: (function () {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const tz1 = TimeZones.find(e => e.zone === tz);
      return tz1 ? tz1.value : ''
    })(),
    specificApptDate: '',
    specificApptTime: '',
    phoneNumber: prefill ? '' : '',
    configurableQuestions: activeQuestionList.length > 0 ? activeQuestionList.reduce((acc, q) => {
      acc[q.question] = '';
      return acc;
    }, {}) : {},
  };
};
